<template>
	<div class="beauty">
		<div class="beauty__table beauty__title">
			<table class="simple-table">
				<tr>
					<th>타이틀 등록</th>
				</tr>
				<tr>
					<td>
						<InputWithButton
							v-model="beautyTitle"
							placeholder="타이틀"
							button-text="등록"
							@click="addTitle"
						/>
					</td>
				</tr>
			</table>
		</div>
		<ManagingSection class="beauty__section" :column-count="3">
			<ManagingBox title="홈 > 어워드 <br> 모듈 캐시">
				<div class="beauty__section-button">
					<RadioList
						v-model="isExposure"
						:radio-list="exposureList"
						value-name="name"
					/>
					<button class="btn blue" @click="changeExposure">
						변경
					</button>
				</div>
				<p class="beauty__notice">
					* 즉시 적용되는 캐시 ( 배치랑은 상관없음 ), 이미 노출중인
					어워드 모듈 캐시를 재적용하려면 미노출후에 다시 노출로 해야
					캐시가 재적용됩니다
				</p>
			</ManagingBox>
			<ManagingBox title="홈 > 메인 <br> 어워드 수상제품 <br> 모듈">
				<div class="beauty__section-button">
					<RadioList
						v-model="isHomeExposure"
						:radio-list="homeExposureList"
						value-name="name"
					/>
					<button class="btn blue" @click="changeHomeExposure">
						변경
					</button>
				</div>
				<p class="beauty__notice">
					* 매일 새벽 1시 캐시가 되지만 앱에서 노출/미노출 처리는 즉시
					이뤄집니다
				</p>
			</ManagingBox>
			<ManagingBox
				title="홈/어워드 홈 <br> (어워드 수상제품 <br> 모듈캐시)"
			>
				<div class="beauty__section-button">
					<button class="btn blue" @click="changeAwardCache">
						캐시적용
					</button>
				</div>
				<p class="beauty__notice">
					* 캐시적용버튼 클릭시 홈/어워드 홈에 어워드 관련 수상제품
					모듈캐시는 반영되는데 시간이 5분정도 소요되니
					참고부탁드립니다
				</p>
			</ManagingBox>
		</ManagingSection>
		<span v-if="exposureNum" class="beauty__section-notice"
			>- 현재 노출중인 어워드 항번은
			<strong>{{ exposureNum }}</strong> 입니다.</span
		>
		<table class="table-main">
			<thead>
				<tr>
					<th>항번</th>
					<th>타이틀</th>
					<th>노출시작</th>
					<th class="beauty__table-img">상단배너 (1125 x 318)</th>
					<th>목록이미지 v.2/v.3</th>
					<th>커버이미지 v.3</th>
					<th>수상제품 배경이미지 (1024 x 576)</th>
					<th>선정기준이미지 v.3</th>
					<th>동작</th>
				</tr>
			</thead>
			<tbody>
				<tr
					v-for="(list, index) in beautyAwardList"
					:key="list.idHitProducts"
					:class="[
						{ beauty__display: exposureNum === list.idHitProducts },
					]"
				>
					<td>
						{{ `${list.idHitProducts}(v${list.version || '-'})` }}
					</td>
					<td>
						<div class="beauty__table__title">
							<input
								type="text"
								placeholder="title"
								v-model="list.hitText"
								@input="getAwardTitle(index, $event)"
							/>
						</div>
					</td>
					<td>
						<div class="beauty__table__range">
							<form
								:id="`create-beauty-awards-${list.idHitProducts}(v${list.version || '-'})`"
								@submit.prevent="
									modifyAward(list.idHitProducts, index)
								"
							>
								<DateBox
									:value="list.startOnStr"
									@input="getStartOn(index, $event)"
								/>
							</form>
							<button
								class="btn"
								:style="{ background: list.activeColor }"
							>
								{{ list.display }}
							</button>
						</div>
					</td>
					<td>
						<div class="beauty__award-image">
							<ImageExif
								:src="list.bannerImg"
								v-if="!!list.bannerImg"
								class="beauty__banner-image"
								@click.native="viewOriginImg(list.bannerImg)"
							/>
							<input
								placeholder="상단배너"
								type="file"
								ref="topBanner"
								@change="
									handleFileChange($event, index, 'topBanner')
								"
							/>
						</div>
					</td>
					<td>
						<div class="beauty__award-image">
							<ImageExif
								:src="list.listImageV2"
								v-if="!!list.listImageV2"
								class="beauty__banner-image"
								@click.native="viewOriginImg(list.listImageV2)"
							/>
							<input
								placeholder="목록이미지"
								type="file"
								ref="listImage"
								@change="
									handleFileChange($event, index, 'listImage')
								"
							/>
						</div>
					</td>
					<td>
						<div class="beauty__award-image">
							<ImageExif
								:src="list.coverImageV3"
								v-if="!!list.coverImageV3"
								class="beauty__banner-image"
								@click.native="viewOriginImg(list.coverImageV3)"
							/>
							<input
								placeholder="커버이미지"
								type="file"
								ref="coverImage"
								@change="
									handleFileChange(
										$event,
										index,
										'coverImage'
									)
								"
							/>
						</div>
					</td>
					<td>
						<div class="beauty__award-image">
							<ImageExif
								:src="list.hitproductImage"
								v-if="!!list.hitproductImage"
								class="beauty__banner-image"
								@click.native="
									viewOriginImg(list.hitproductImage)
								"
							/>
							<input
								placeholder="수상제품 배경이미지"
								type="file"
								ref="hitproductImage"
								@change="
									handleFileChange(
										$event,
										index,
										'hitproductImage'
									)
								"
							/>
						</div>
					</td>
					<td>
						<div class="beauty__award-image">
							<ImageExif
								:src="list.choiceImageV3"
								v-if="!!list.choiceImageV3"
								class="beauty__banner-image choice"
								@click.native="
									viewOriginImg(list.choiceImageV3)
								"
							/>
							<button
								class="btn red"
								v-if="!!list.choiceImageV3"
								@click="
									deleteAwards(
										list.idHitProducts,
										'choiceImg'
									)
								"
							>
								이미지 삭제
							</button>
							<input
								placeholder="선정기준이미지"
								type="file"
								ref="choiceImage"
								@change="
									handleFileChange(
										$event,
										index,
										'choiceImage'
									)
								"
							/>
						</div>
					</td>
					<td>
						<div class="beauty__button">
							<button
								:form="`create-beauty-awards-${list.idHitProducts}(v${list.version || '-'})`"
								type="submit"
								class="btn orange"
								v-text="'수정'"
							/>
							<button
								class="btn gray"
								@click="deleteAwards(list.idHitProducts)"
							>
								삭제
							</button>
							<button
								class="btn blue"
								@click="
									$router.push(
										`/product/award-product-list?id=${list.idHitProducts}`
									)
								"
							>
								상품목록
							</button>
						</div>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>
<script>
	import InputWithButton from '@/components/InputWithButton';
	import DateBox from '@/components/DateBox';
	import moment from 'moment';
	import ImageExif from '@/components/ImageExif.vue';
	import { mapState } from 'vuex';
	import Util, { imageUpload } from '@/util';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import RadioList from '@/components/RadioList.vue';

	export default {
		name: 'CreateBeautyAwards',
		components: {
			InputWithButton,
			DateBox,
			ImageExif,
			ManagingBox,
			ManagingSection,
			RadioList,
		},
		data() {
			return {
				beautyTitle: '',
				exposureTime: [],
				dataList: [],
				isDisplay: {
					0: '미노출',
					1: '노출',
					2: '노출대기',
				},
				awardList: [],
				awardTitle: [],
				activeColor: '',
				awardFileList: [],
				group: 'beauty',
				uploadImagePath: {
					listFileDir: '',
					listFileSaveName: '',
					coverFileDir: '',
					coverFileSaveName: '',
					choiceFileDir: '',
					choiceFileSaveName: '',
					hitproductFileDir: '',
					hitproductFileSaveName: '',
					topBannerUrl: '',
				},
				isExposure: 0,
				isHomeExposure: 0,
				exposureList: [
					{
						id: 0,
						name: '미노출',
					},
					{
						id: 1,
						name: '노출',
					},
				],
				homeExposureList: [
					{
						id: 0,
						name: '미노출',
					},
					{
						id: 1,
						name: '노출',
					},
				],
				exposureNum: null,
			};
		},
		mounted() {
			this.getList();
		},
		computed: {
			...mapState('env', ['IMAGE_STORAGE_PATH']),
			...mapState('award', ['beautyAwardList']),
		},
		methods: {
			async addTitle() {
				const params = {
					hitText: this.beautyTitle,
				};
				if (!confirm('정말 등록하시겠습니까?')) return;
				try {
					await this.$axiosAdmin2.post('/api/award', params);
					this.getList();
					this.beautyTitle = '';
				} catch (err) {
					console.error(err);
				}
			},
			async getList() {
				try {
					await this.$store.dispatch('award/setApiData');
					this.getDisplay();
					this.beautyAwardList.forEach((item, idx) => {
						item.display = this.isDisplay[item.isDisplay];
						item.startOnStr = moment(item.startOnStr).format(
							'YYYY-MM-DD HH:mm'
						);
						switch (item.isDisplay) {
							case 0:
								item.activeColor = '#D1D1D6';
								break;
							case 1:
								item.activeColor = '#0FA639';
								break;
							case 2:
								item.activeColor = '#48484A';
								break;
							default:
								break;
						}
						item.bannerImg =
							item.doc &&
							`${this.IMAGE_STORAGE_PATH}${JSON.parse(item.doc)?.top_banner_url}`;
						this.exposureTime[idx] =
							item.startOnStr === 'Invalid date'
								? undefined
								: item.startOnStr;
						this.awardTitle[idx] = item.hitText;
					});
				} catch (err) {
					console.error(err);
				}
			},
			async getDisplay() {
				try {
					const { data } = await this.$axiosAdmin2.get(
						'/api/award/current-module'
					);

					if (data.awardHomeModuleId) {
						this.isExposure = 1;
						this.exposureNum = data.awardHomeModuleId;
					} else {
						this.isExposure = 0;
					}

					if (data.homeAwardProductModuleId) {
						this.isHomeExposure = 1;
						this.exposureNum = data.homeAwardProductModuleId;
					} else {
						this.isHomeExposure = 0;
					}

					if (
						!data.homeAwardProductModuleId &&
						!data.awardHomeModuleId
					) {
						this.exposureNum = null;
					}
				} catch (err) {
					console.error(err);
					if (err && err.response && err.response.status === 404) {
						alert(err.response.data.message);
					}
				}
			},
			getAwardTitle: _.debounce(async function (index, event) {
				this.awardTitle[index] = event.target.value;
			}, 500),

			getStartOn(index, value) {
				this.exposureTime[index] = value;
			},
			readFile(file, name, index) {
				return new Promise(resolve => {
					const reader = new FileReader();
					reader.onload = e => {
						const file = new Image();
						file.src = e.target.result;

						file.onload = () => {
							const width = file.width;
							const height = file.height;

							if (name === 'hitproductImage') {
								const setWidth = 1024;
								const setHeight = 576;

								if (
									setWidth !== width ||
									setHeight !== height
								) {
									alert(
										`이미지 사이즈가  ${setWidth} x ${setHeight}가 아닙니다`
									);
									this.$refs[name][index].value = '';
									return;
								}
							}

							resolve(e);
						};
					};
					reader.readAsDataURL(file);
				});
			},

			addImgList(urlList, files, index, name) {
				const list = urlList.map((url, idx) => {
					const srcObj = {
						src: url,
						fileObject: files[idx],
						extension: files[idx].type.split('/').pop(),
					};
					return srcObj;
				});

				if (!this.awardFileList[index]) {
					this.awardFileList[index] = {
						topBanner: '',
						listImage: '',
						coverImage: '',
						choiceImage: '',
						hitproductImage: '',
					};
				}
				this.awardFileList[index][name] = list[0];
			},
			async handleFileChange(event, index, name) {
				const files = [...event.target.files];
				const readFileList = await Promise.all(
					files.map(file => this.readFile(file, name, index))
				);
				const urlList = readFileList.map(({ target }) => target.result);
				this.addImgList(urlList, files, index, name);
			},

			async uploadImageFile(imageObj, pathKey, saveNameKey) {
				const { extension, fileObject } = imageObj;

				try {
					const res = await imageUpload(
						extension,
						this.group,
						fileObject
					);
					const filePath = res.config.data.get('key');
					const fileSaveName = filePath.split('/').pop();
					const imgPath = filePath.replace(/\/[^/]+\/?$/, '');
					const path = `/${pathKey === 'topBannerUrl' ? filePath : imgPath}`;

					this.uploadImagePath[pathKey] = path;

					if (saveNameKey) {
						this.uploadImagePath[saveNameKey] = fileSaveName;
					}
				} catch (err) {
					console.error(err);
				}
			},

			async uploadImage(idx) {
				const uploadImgList = this.awardFileList[idx];

				const uploadPromise = [];

				if (uploadImgList.topBanner) {
					uploadPromise.push(
						this.uploadImageFile(
							uploadImgList.topBanner,
							'topBannerUrl'
						)
					);
				}
				if (uploadImgList.choiceImage) {
					uploadPromise.push(
						this.uploadImageFile(
							uploadImgList.choiceImage,
							'choiceFileDir',
							'choiceFileSaveName'
						)
					);
				}
				if (uploadImgList.listImage) {
					uploadPromise.push(
						this.uploadImageFile(
							uploadImgList.listImage,
							'listFileDir',
							'listFileSaveName'
						)
					);
				}
				if (uploadImgList.coverImage) {
					uploadPromise.push(
						this.uploadImageFile(
							uploadImgList.coverImage,
							'coverFileDir',
							'coverFileSaveName'
						)
					);
				}
				if (uploadImgList.hitproductImage) {
					uploadPromise.push(
						this.uploadImageFile(
							uploadImgList.hitproductImage,
							'hitproductFileDir',
							'hitproductFileSaveName'
						)
					);
				}

				await Promise.all(uploadPromise);
			},

			async modifyAward(productId, idx) {
				if (this.awardFileList[idx]) {
					await this.uploadImage(idx);
				}
				const startOn = this.exposureTime[idx]
					? moment(this.exposureTime[idx]).valueOf()
					: '';
				const hitText = this.awardTitle[idx];
				const idHitProducts = productId;
				const params = {
					...this.uploadImagePath,
					startOn,
					hitText,
					idHitProducts,
				};
				try {
					await this.$axiosAdmin2.put(
						`/api/award/${productId}`,
						params
					);
					alert('수정이 완료되었습니다.');
					this.initList();
					this.getList();
				} catch (error) {
					console.error(error);
					alert(
						'수정 실패하였습니다. 계속해서 문제가 발생할 경우 개발팀에 문의 주시기 바랍니다.'
					);
				}
			},

			deleteFileName(idx) {
				const refList = [
					'topBanner',
					'listImage',
					'coverImage',
					'choiceImage',
					'hitproductImage',
				];
				refList.forEach(item => (this.$refs[item][idx].value = ''));
			},

			initList() {
				this.uploadImagePath = {
					listFileDir: '',
					listFileSaveName: '',
					coverFileDir: '',
					coverFileSaveName: '',
					choiceFileDir: '',
					choiceFileSaveName: '',
					hitproductFileDir: '',
					hitproductFileSaveName: '',
					topBannerUrl: '',
				};
				this.awardFileList = [];
				const refList = [
					'topBanner',
					'listImage',
					'coverImage',
					'choiceImage',
					'hitproductImage',
				];
				this.awardList.forEach((_, index) => {
					refList.forEach(
						item => (this.$refs[item][index].value = '')
					);
				});
			},
			viewOriginImg(imgPath) {
				const img = [imgPath];
				if (!imgPath) {
					alert(
						'이미지 불러오기에 실패하였습니다. 지속적인 문제 발생시 개발팀에 문의바랍니다.'
					);
				} else {
					Util.popupImages(img, 500, true);
				}
			},

			async deleteAwards(productId, name) {
				if (!confirm('정말 삭제하시겠습니까?')) return;
				try {
					if (name === 'choiceImg') {
						await this.$axiosAdmin2.delete(
							`/api/award/${productId}/choiceImg`
						);
					} else {
						await this.$axiosAdmin2.delete(
							`/api/award/${productId}`
						);
					}
					alert('삭제되었습니다.');
					this.initList();
					this.getList();
				} catch (err) {
					if (err.response && err.response.status === 400) {
						alert(
							'해당 히트상품의 카테고리를 모두 삭제후에 삭제가 가능합니다'
						);
					} else {
						alert(
							'삭제 실패하였습니다. 계속해서 문제 발생 시 개발팀에 문의해주세요'
						);
					}
				}
			},

			async changeExposure() {
				try {
					await this.$axiosAdmin2.put(
						`/api/award/module-update?display=${this.isExposure === 1 ? 'true' : 'false'}`
					);
					alert('변경되었습니다.');
					this.getList();
				} catch (err) {
					console.error(err);
					if (err && err.response && err.response.status === 400) {
						alert(err.response.data.message);
					}
					this.isExposure = 0;
				}
			},
			async changeHomeExposure() {
				try {
					await this.$axiosAdmin2.put(
						`/api/award/home-product-module-update?display=${this.isHomeExposure === 1 ? 'true' : 'false'}`
					);
					alert('변경되었습니다.');
					this.getList();
				} catch (err) {
					conosle.error(err);
					alert(
						'변경에 실패하였습니다. 계속해서 문제 발생 시 개발팀에 문의주세요.'
					);
				}
			},
			async changeAwardCache() {
				if (!confirm('캐시적용을 하시겠습니까?')) return;
				try {
					await this.$axiosAdmin2.put(
						`/api/award/home-product-module-update-cache`
					);
					alert('변경되었습니다.');
					this.getList();
				} catch (err) {
					console.error(err);
					alert(
						'변경에 실패하였습니다. 계속해서 문제 발생 시 개발팀에 문의주세요.'
					);
				}
			},
		},
	};
</script>
<style lang="scss" scoped>
	.beauty {
		margin-top: 20px;
		.simple-table {
			width: 80%;
		}
		&__notice {
			margin-top: 20px;
			color: #8a8a8b;
		}
		&__table {
			margin-bottom: 50px;
		}
		&__title {
			display: flex;
			justify-content: center;
		}
		&__section {
			margin-bottom: 20px;
			width: 1290px;
			span {
				margin-top: 10px;
			}
		}

		&__section-notice {
			display: block;
			margin-bottom: 10px;
		}
		&__section-button {
			display: flex;
			align-items: center;
			width: 100%;
			button {
				margin-left: 30px;
			}
		}
		&__box {
			flex-direction: row;
			justify-content: center;
			align-items: center;
			gap: 26px;
		}
		&__section-title {
			font-size: 18px;
			font-weight: 600;
		}
		&__section-radio {
			font-size: 18px;
		}
		&__radio {
			margin-left: 20px;
		}
		&__button {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			gap: 5px;
		}
		&__award-image {
			width: 200px;
			margin: 0 auto;
			.btn {
				margin-bottom: 20px;
			}
			input {
				white-space: normal;
				overflow: auto;
				word-wrap: break-word;
				width: 180px;
			}
		}
		&__banner-image {
			width: 100%;
			margin: 0 auto 30px;
			cursor: pointer;
			&.choice {
				height: 250px;
				margin: 0 auto 20px;
				width: auto;
			}
		}
		&__table__title {
			width: 300px;
		}
		&__table__range {
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			gap: 9px;
			.btn {
				cursor: default;
				border-radius: 3px;
				color: #fff;
				border: none;
			}
		}
		&__display {
			background-color: #f0f3fb;
		}
	}
</style>
